import React from 'react';
import { cl } from '../data/cl';

const ConsultingTemplate = () => {
  const data = cl;

  const invoice = {
    companyName: data?.companyName || "Consultancy Name",
    invoiceNumber: data?.invoiceNumber || "00-000000",
    workOrder: data?.workOrder || "00-000000",
    date: data?.date || "7/15/2026",
    clientName: data?.clientName || "[Name]",
    customerId: data?.customerId || "",
    mailingInfo: data?.mailingInfo || {},
    billTo: data?.billTo || {},
    hourlyServices: data?.hourlyServices || [],
    otherServices: data?.otherServices || [],  
    subtotalHourly: data?.subtotalHourly || "0.00",
    subtotalOther: data?.subtotalOther || "0.00",
    totalTax: data?.totalTax || "0.00",
    sh: data?.sh || "0.00",
    discount: data?.discount || "0.00",
    total: data?.total || "0.00",
    comments: data?.comments || []
  };

  const themeColor = "text-[#D97706]"; 

  return (
    <div id="consulting-invoice" className="bg-white p-12 text-gray-800 font-sans mx-auto shadow-sm">

      <div className="flex justify-between items-start mb-5">
        <h1 className={`text-4xl font-normal ${themeColor}`}>{invoice.companyName}</h1>
        <h2 className={`text-4xl font-light uppercase tracking-widest ${themeColor} opacity-70`}>
          Invoice
        </h2>
      </div>

      {/* INVOICE META */}
      <div className="grid grid-cols-2 gap-8 text-xs mb-5">
        <div className="space-y-1">
          <div className="flex justify-between w-48 font-bold border-b">
            <span>INVOICE #</span> <span>{invoice.invoiceNumber}</span>
          </div>
          <div className="flex justify-between w-48 font-bold border-b">
            <span>WORK ORDER #</span> <span>{invoice.workOrder}</span>
          </div>
        </div>
        <div className="text-right font-bold border-b self-end">
          <span>DATE</span> <span className="ml-10">{invoice.date}</span>
        </div>
      </div>

      {/* ADDRESS SECTION */}
      <div className="grid grid-cols-2 gap-20 text-xs mb-5">
        {/* MAILING INFO */}
        <div className="flex gap-4">
          <span className="font-bold text-gray-400">MAILING INFO</span>
          <p>
            {invoice.mailingInfo.addressLine1}<br/>
            {invoice.mailingInfo.addressLine2}<br/>
            Phone: {invoice.mailingInfo.phone}
          </p>
        </div>

        {/* BILL TO */}
        <div className="flex gap-4">
          <span className="font-bold text-gray-400">BILL TO</span>
          <div>
            <p className="font-bold">{invoice.billTo.name}</p>
            <p>
              Customer ID: {invoice.billTo.customerId}<br/>
              {invoice.billTo.addressLine1}<br/>
              {invoice.billTo.addressLine2}
            </p>
          </div>
        </div>
      </div>

      {/* HOURLY SERVICES */}
      <div className="mb-5">
        <h3 className={`text-[10px] font-bold uppercase mb-1 ${themeColor}`}>Hourly Services</h3>
        <table className="w-full text-xs border-t-2 border-[#D97706]">
          <thead>
            <tr className="text-left text-[10px] uppercase text-gray-400">
              <th className="py-2">Description</th>
              <th className="py-2 text-center w-20">Hours</th>
              <th className="py-2 text-center w-24">Rate</th>
              <th className="py-2 text-right w-24">Amount</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-dotted border-b">
            {invoice.hourlyServices.map((item, i) => (
              <tr key={i}>
                <td className="py-2">{item.desc}</td>
                <td className="py-2 text-center">{item.hours}</td>
                <td className="py-2 text-center">{item.rate}</td>
                <td className="py-2 text-right">{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end mt-2 text-xs font-bold">
          <span className="mr-8">SUBTOTAL</span> <span>₹{invoice.subtotalHourly}</span>
        </div>
      </div>

      {/* OTHER SERVICES */}
      <div className="mb-5">
        <h3 className={`text-[10px] font-bold uppercase mb-1 ${themeColor}`}>Other Services and Charges</h3>
        <table className="w-full text-xs border-t-2 border-[#D97706]">
          <thead>
            <tr className="text-left text-[10px] uppercase text-gray-400">
              <th className="py-2">Description</th>
              <th className="py-2 text-right w-24">Amount</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-dotted border-b">
            {invoice.otherServices.map((item, i) => (
              <tr key={i}>
                <td className="py-2">{item.desc}</td>
                <td className="py-2 text-right">{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end mt-2 text-xs font-bold">
          <span className="mr-8">SUBTOTAL</span> <span>₹{invoice.subtotalOther}</span>
        </div>
      </div>

      {/* FOOTER */}
      <div className="flex justify-between items-start">
        <div className="w-1/2">
          <h4 className={`text-[10px] font-bold uppercase mb-1 border-b-2 ${themeColor}`}>
            Other Comments
          </h4>
          <p className="text-[10px] text-gray-500 mt-2">
            {invoice.comments.map((c, i) => (
              <span key={i}>{i + 1}. {c}<br/></span>
            ))}
          </p>
        </div>

        <div className="w-48 space-y-1 text-xs">
          <div className="flex justify-between"><span>TOTAL TAX</span> <span>{invoice.totalTax}</span></div>
          <div className="flex justify-between"><span>S & H</span> <span>{invoice.sh}</span></div>
          <div className="flex justify-between"><span>(DISCOUNT)</span> <span>({invoice.discount})</span></div>
          <div className="flex justify-between font-bold bg-gray-100 p-2 border-y-2 border-gray-400 text-sm">
            <span>TOTAL</span> <span>₹{invoice.total}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultingTemplate;
